import { FC, useEffect } from 'react'
import { Box, CircularProgress } from '@mui/material'
import useAnalytics from '../hooks/useAnalytics'

const SendUserIdToGoogleAnalytics: FC = () => {
  const { setUserId } = useAnalytics('auth_flow_completed')

  useEffect(() => {
    const userId = document.querySelector<HTMLInputElement>('#extension_GlobalId')!.value
    const eventName = document.querySelector<HTMLInputElement>('#eventName')!.value
    setUserId(userId, eventName)
    document.querySelector<HTMLButtonElement>('#continue')!.click()
  }, [setUserId])

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <CircularProgress />
    </Box>
  )
}

export default SendUserIdToGoogleAnalytics
